module.exports = __webpack_public_path__ + "img/order-detail-hd-bg.53109983.png";